import { s__ } from '~/locale';
import { GENIE_CHAT_NEW_MESSAGE } from 'ee/ai/constants';

export const SLASH_COMMANDS = [
  {
    name: GENIE_CHAT_NEW_MESSAGE,
    description: s__('DuoAgenticChat|Start a new conversation'),
    shouldSubmit: false,
    startOnly: true,
  },
  {
    /* eslint-disable-next-line @gitlab/no-hardcoded-urls -- a slash command, not a URL */
    name: '/compact',
    description: s__('DuoAgenticChat|Summarize and compact this conversation'),
    shouldSubmit: false,
    startOnly: true,
  },
];
